(function () {
  var displayDataMap = new WeakMap();

  function getVariants(display) {
    if (displayDataMap.has(display)) return displayDataMap.get(display);
    var el = display.querySelector('.product-variants-json');
    if (!el) return null;
    try {
      var variants = JSON.parse(el.textContent);
      displayDataMap.set(display, variants);
      return variants;
    } catch (e) {
      return null;
    }
  }

  function getSelectedOptions(display) {
    var opts = [];
    display.querySelectorAll('.variants-option-group').forEach(function (g) {
      var sel = g.querySelector('.variant-option-btn.is-selected');
      if (sel) opts[parseInt(g.dataset.optionIndex, 10)] = sel.dataset.value;
    });
    return opts;
  }

  function findVariant(variants, selected) {
    return variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return !selected[i] || selected[i] === opt;
      });
    });
  }

  function formatMoney(cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function updatePrice(card, variant) {
    var el = card.querySelector('.product-card__price');
    if (!el) return;

    var hasSale =
      variant.compare_at_price && variant.compare_at_price > variant.price;

    if (hasSale) {
      el.className = 'product-card__price mb-1 product-card__pricesale';
      el.innerHTML =
        formatMoney(variant.price) +
        '<s class="product-card__regular-price">' +
        formatMoney(variant.compare_at_price) +
        '</s>';
    } else {
      el.className = 'product-card__price mb-1';
      el.innerHTML = formatMoney(variant.price);
    }
  }

  function updateCard(card, variant) {
    card.querySelectorAll('.js-grid-cart, [data-id]').forEach(function (el) {
      el.setAttribute('data-id', variant.id);
      if (typeof jQuery !== 'undefined') jQuery(el).data('id', variant.id);
    });

    card.querySelectorAll('.js-grid-cart').forEach(function (btn) {
      if (variant.available) {
        btn.classList.remove('disabled');
        btn.removeAttribute('disabled');
      } else {
        btn.classList.add('disabled');
      }
    });

    updatePrice(card, variant);

    if (variant.featured_image) {
      var img = card.querySelector('.first-image');
      if (img) {
        img.setAttribute('src', variant.featured_image);
        img.setAttribute('srcset', variant.featured_image);
        if (img.dataset.src !== undefined) img.dataset.src = variant.featured_image;
      }
    }
  }

  function initDisplay(display) {
    if (display.dataset.variantInit) return;
    display.dataset.variantInit = 'true';

    var card = display.closest('.js-product-card');
    if (!card) return;

    var variants = getVariants(display);
    if (!variants || !variants.length) return;

    var first =
      variants.find(function (v) { return v.available; }) || variants[0];

    display.querySelectorAll('.variants-option-group').forEach(function (g) {
      var idx = parseInt(g.dataset.optionIndex, 10);
      var target = first.options[idx];
      g.querySelectorAll('.variant-option-btn').forEach(function (btn) {
        if (btn.dataset.value === target) btn.classList.add('is-selected');
      });
    });

    updateCard(card, first);
  }

  function initAll() {
    document.querySelectorAll('.product-variants-display').forEach(initDisplay);
  }

  /* ── Variant option click (bubble phase, delegated) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.variant-option-btn');
    if (!btn || btn.disabled) return;

    var group = btn.closest('.variants-option-group');
    var display = btn.closest('.product-variants-display');
    var card = display && display.closest('.js-product-card');
    if (!group || !display || !card) return;

    e.preventDefault();

    group.querySelectorAll('.variant-option-btn').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');

    var variants = getVariants(display);
    if (!variants) return;

    var matched = findVariant(variants, getSelectedOptions(display));
    if (matched) updateCard(card, matched);
  });

  /* ── Add-to-cart intercept (capture phase, fires before theme.js jQuery handler) ── */
  document.addEventListener(
    'click',
    function (e) {
      var cartBtn = e.target.closest('.js-grid-cart');
      if (!cartBtn) return;

      var card = cartBtn.closest('.js-product-card');
      if (!card || !card.querySelector('.product-variants-display')) return;

      e.preventDefault();
      e.stopPropagation();

      if (cartBtn.classList.contains('disabled')) return;

      var variantId = cartBtn.getAttribute('data-id');
      if (!variantId) return;

      cartBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return fetch('/cart.js', {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });
        })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: String(variantId),
                data: {
                  itemCount: cart.item_count,
                  variantId: String(variantId),
                },
              },
            })
          );

          document.querySelector('cart-drawer-component')?.open?.();

          if (typeof theme !== 'undefined' && theme.miniCart) {
            theme.miniCart.generateCart();
            theme.miniCart.updateElements();
          }

          var miniCartEl = document.querySelector('.js-mini-cart');
          if (miniCartEl) miniCartEl.classList.add('active');
        })
        .catch(function (err) {
          console.error('variant-selector: add to cart error', err);
        })
        .finally(function () {
          cartBtn.classList.remove('is-loading');
        });
    },
    true
  );

  /* ── Init ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (
            node.classList.contains('product-variants-display') ||
            node.querySelector('.product-variants-display')
          ) {
            initAll();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
